import VehicleDetailCommonWrap from "./VehicleDetailCommonWrap";

export default VehicleDetailCommonWrap;
